import React from "react";
import { Plus, Inbox } from "lucide-react";
import { frDate } from "@/lib/deals";

const NEED = { credit: "Crédit", assurance: "Assurance", placement: "Placement" };

export default function LeadsInbox({ leads, onCreate }) {
  if (leads.length === 0) {
    return (
      <div data-testid="leads-empty" className="text-center py-16 bg-white rounded-3xl border border-md-border text-md-muted">
        <Inbox className="w-10 h-10 mx-auto mb-3 opacity-40" /> Toutes les demandes du site ont été transformées en affaires.
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="leads-inbox">
      {leads.map((l) => (
        <div key={l.id} data-testid={`lead-row-${l.id}`} className="bg-white border border-md-border rounded-2xl p-5 flex flex-col md:flex-row md:items-center gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex flex-wrap items-center gap-2 mb-1">
              {l.needs.map((n) => <span key={n} className="text-[10px] uppercase font-bold tracking-widest text-md-secondary">{NEED[n] || n}</span>)}
              <span className="text-xs text-md-muted">· {frDate(l.created_at)} · {l.profile || "—"}</span>
              {!l.consent_request && <span data-testid={`lead-email-only-${l.id}`} className="text-[10px] uppercase font-bold bg-red-50 text-red-700 px-2 py-0.5 rounded-full">Ne pas appeler — email uniquement</span>}
            </div>
            <div className="font-serif text-lg text-md-primary">{l.full_name}</div>
            <div className="text-xs text-md-muted">{l.email}{l.phone ? ` · ${l.phone}` : ""}{l.amount ? ` · ${l.amount}` : ""}</div>
            {l.project_details && <p className="text-sm text-md-text/80 mt-1.5 line-clamp-2">{l.project_details}</p>}
          </div>
          <button data-testid={`lead-create-deal-${l.id}`} onClick={() => onCreate(l)} className="inline-flex items-center gap-1.5 bg-md-primary hover:bg-md-primaryHover text-white px-5 py-2.5 rounded-full text-sm font-semibold self-start md:self-center transition-colors">
            <Plus className="w-4 h-4" /> Créer l'affaire
          </button>
        </div>
      ))}
    </div>
  );
}
